import type { TPaymentMethodMode } from '../../store/types';

export const isPaymentMethodWithRemoteMethod = (mode: TPaymentMethodMode) => (
  mode === 'remote' || mode === 'h2h'
);

export const isPaymentMethodWithCustomFlow = (mode: TPaymentMethodMode) => (
  mode === 'custom' || mode === 'h2h'
);
